import { Component } from '@angular/core';
import { googleTagInitialize } from './shared/functions/google-tag-initialize';
import { forkJoin, Observable } from 'rxjs';
import { ISitemap } from '@neb/lit-storybook';
import { EnumInjectionTokens, GemsService } from './shared';
import { IEnvironment } from './shared/interfaces';
import { tap } from 'rxjs/operators';
import { Inject } from '@angular/core';

interface IContent {
  siteMap: ISitemap;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false
})
export class AppComponent {
  content$: Observable<IContent>;

  constructor(
    private gemsService: GemsService,
    @Inject(EnumInjectionTokens.Environment) private environment: IEnvironment
  ) { }

  ngOnInit() {
    this.content$ = forkJoin({
      siteMap: this.gemsService.siteMap().pipe(
        tap((x: ISitemap) => googleTagInitialize(x.google_analytics))
      )
    });
  }
}
